export const platformColorMap = {
  PC: '#4C526E',
  Nintendo: '#EF5858',
  Xbox: '#4DAB7D',
  PS: '#0070D1',
};
